module.exports = __webpack_public_path__ + "static/media/live.5e9be2ad.svg";